import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { connect } from 'react-redux';
import { selectors, actions } from '../redux';
import { getSelectedFolderIds } from '../redux/selectors';
const mapStateToProps = (state, { collectibleDeviation: { deviationId  } , isPrivateCollections  })=>_object_spread_props(_object_spread({}, selectors.getUserCollections(state, deviationId, isPrivateCollections)), {
        selectedFolderIds: getSelectedFolderIds(state, deviationId, isPrivateCollections)
    });
const mapDispatchToProps = {
    toggleCollection: actions.toggleCollection
};
export default connect(mapStateToProps, mapDispatchToProps);
